import { render, staticRenderFns } from "./EditEventos.vue?vue&type=template&id=47e20d3d&"
import script from "./EditEventos.vue?vue&type=script&lang=js&"
export * from "./EditEventos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports